import { BaseService } from 'core/common/services';
import { AuthData } from '../entities';
import { AuthDtoMapper } from '../mappers';
import { AuthDataDto } from './dto';

export class AuthService extends BaseService {
  async signInByToken(token: string) {
    await this.httpClient.post(`/auth/authenticate-by-token/${token}`);
  }

  async getAskNebulaAuthenticationToken(): Promise<AuthData> {
    const { data } = await this.httpClient.get<AuthDataDto>('/user/asknebula');

    const dtoMapper = new AuthDtoMapper();

    return dtoMapper.toEntity(data);
  }
}
